var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-header",attrs:{"id":("wizard-header" + (_vm.ecommerce ? '-ecommerce' : ''))}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",class:{
                'col-md-8': !_vm.fullWidth && !_vm.ecommerce,
                'col-md-10': _vm.ecommerce
                }},[_c('h4',{class:{'c6': _vm.ecommerce, 'h4b c7': !_vm.ecommerce}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"p2n",class:{
                    'c24 subtitle': _vm.ecommerce, 
                    'c14': !_vm.ecommerce
                },domProps:{"innerHTML":_vm._s(_vm.description)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }